import React from 'react';
import { Landmark, Scale, MapPin, Handshake, Coins, Users } from 'lucide-react';

const items = [
  { icon: Landmark, title: 'Government, regulatory matters & approvals' },
  { icon: Scale, title: 'Legal disputes, crises & reputation matters' },
  { icon: MapPin, title: 'Land, property & complex asset matters' },
  { icon: Handshake, title: 'Stuck transactions & special situations' },
  { icon: Coins, title: 'Capital raising, deployment & co‑investors' },
  { icon: Users, title: 'Decision‑maker access & strategic introductions' },
];

export default function CrisisSection() {
  return (
    <section id="crisis" className="px-4 md:px-6 pt-6 md:pt-8">
      <div className="max-w-7xl mx-auto bg-white rounded-[32px] md:rounded-[40px] px-6 md:px-12 py-20 md:py-28 border border-neutral-200">
        <div className="text-center reveal">
          <span className="inline-block text-[11px] font-semibold tracking-[0.2em] uppercase text-neutral-800 bg-neutral-100 border border-neutral-200 px-3 py-1.5 rounded-full">
            What we resolve
          </span>
          <h2 className="font-display-bold mt-6 text-4xl md:text-[64px] leading-[1.05] text-neutral-900">
            What <span className="relative inline-block">
              <span className="relative z-10">we can help</span>
              <span className="absolute -inset-x-1 bottom-1 md:bottom-2 h-2 md:h-4 -z-0 rounded bg-[#E8DBC6]" />
            </span>
            <br />
            you navigate
          </h2>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                className="card-hover reveal relative rounded-[24px] p-7 md:p-9 bg-neutral-50 border border-neutral-200"
                style={{ transitionDelay: `${(i % 6) * 60}ms` }}
              >
                <div className="h-16 w-16 rounded-2xl flex items-center justify-center bg-white border border-neutral-200">
                  <Icon className="h-8 w-8 text-neutral-900" strokeWidth={1.75} />
                </div>
                <h3 className="font-display-bold mt-7 text-[20px] md:text-[22px] leading-snug text-neutral-900 max-w-xs">
                  {item.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
